export const customTextLabel = {
  invalidCardNumber: "El número de la tarjeta es inválido",
  expiryError: {
    invalidExpiryDate: "La fecha de expiración es inválida",
    monthOutOfRange: "El mes de expiración debe estar entre 01 y 12",
    yearOutOfRange: "El año de expiración no puede estar en el pasado",
    dateOutOfRange: "La fecha de expiración no puede estar en el pasado",
  },
  invalidCvc: "El código de seguridad es inválido",
  invalidZipCode: "El código postal es inválido",
  cardNumberPlaceholder: "Número de tarjeta",
  expiryPlaceholder: "MM/AA",
  cvcPlaceholder: "CVV",
};

export const SET_ERROR_PAYMENT = "payment_sending";

export const REJECT_PAYMENT =
  "Tu pago ha sido rechazado, por favor verifica los datos de la tarjeta o intenta usando otro medio de pago.";

export const ERROR_PSE_PAYMENT =
  "No se pudo generar el pago por PSE, comuniquesé con un asesor";

export const ERROR_REFERENCES =
  "No se encontró la referencia para la marca especificada";
